import { trpc } from "../api/trpc";

interface UseBookImagesOptions {
  enabled?: boolean;
}

/**
 * Fetches signed cover image URLs for a book.
 */
export const useBookImages = (bookId: string, options?: UseBookImagesOptions) => {
  const enabled = options?.enabled ?? Boolean(bookId);

  return trpc.books.getBookImages.useQuery(
    { bookId },
    {
      enabled,
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 2 * 60 * 60 * 1000, // 2 hours
    },
  );
};
